import 'assets/styles/transitions.css'

import React from 'react'
import { Switch } from 'react-router'
import CssBaseline from '@material-ui/core/CssBaseline'
import { Route, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import Login from 'containers/account/Login'
import Sidebar from 'containers/core/Sidebar'
import Dashboard from 'containers/core/Dashboard'
import PrivateRoute from 'containers/PrivateRoute'
import EmailSent from 'containers/account/EmailSent'
import ToastContainer from 'containers/ToastContainer'
import ManageTraps from 'containers/traps/ManageTraps'
import Overview from 'containers/organisation/Overview'
import Account404 from 'containers/account/PageNotFound'
import NewPassword from 'containers/account/NewPassword'
import Dashboard404 from 'containers/core/Dashboard/404'
import EditDetails from 'containers/account/EditDetails'
import AccountHome from 'containers/account/AccountHome'
import ManageGroups from 'containers/groups/ManageGroups'
import PopoverContainer from 'containers/PopoverContainer'
import TransitionSwitch from 'containers/TransitionSwitch'
import PeopleDetails from 'containers/people/PeopleDetails'
// import EmailSettings from 'containers/account/EmailSettings'
import CreateAccount from 'containers/account/CreateAccount'
import ResetPassword from 'containers/account/ResetPassword'
import PeopleOverview from 'containers/people/PeopleOverview'
import PeopleRequests from 'containers/people/PeopleRequests'
import ChangePassword from 'containers/account/ChangePassword'
import GroupDataDetail from 'containers/groups/GroupDataDetail'
import TrapDataOverview from 'containers/traps/TrapDataOverview'
import ManageGroupTraps from 'containers/groups/ManageGroupTraps'
import GroupDataOverview from 'containers/groups/GroupDataOverview'
import ManageGroupViewers from 'containers/groups/ManageGroupViewers'
import ManageGroupDetails from 'containers/groups/ManageGroupDetails'
import TrapInviteVerify from 'containers/invitations/TrapInviteVerify'
import AccountScreenWrapper from 'containers/core/AccountScreenWrapper'
import AdminInviteVerify from 'containers/invitations/AdminInviteVerify'
import CreateOrganisation from 'containers/organisation/CreateOrganisation'
import OrganisationOverview from 'containers/organisation/OrganisationOverview'
import AdministrationOverview from 'containers/organisation/AdministrationOverview'

import OverviewMap from 'components/organisms/OverviewMap'
import TrapInviteSuccess from 'components/organisms/TrapInviteSuccess'
import PeopleRequestsBadge from 'components/atoms/PeopleRequestsBadge'
import AdminInviteSuccess from 'components/organisms/AdminInviteSuccess'

import { history } from 'utils/routes'

const App = () => (
  <div className="App">
    <CssBaseline />
    <ConnectedRouter history={history}>
      <div>
        <Switch>
          <PrivateRoute path="/account">
            <AccountScreenWrapper protected>
              <TransitionSwitch>
                <Route exact path="/account/home" component={AccountHome} />
                <Route
                  exact
                  path="/account/edit-details"
                  component={EditDetails}
                />
                <Route
                  exact
                  path="/account/change-password"
                  component={ChangePassword}
                />
                {/* <Route exact path='/account/email-notifications' component={EmailSettings} /> */}
                <Route
                  exact
                  path="/account/create-project"
                  component={CreateOrganisation}
                />
                <Route exact path="/account/email-sent" component={() => <EmailSent />} />
                <Route component={Account404} />
              </TransitionSwitch>
            </AccountScreenWrapper>
          </PrivateRoute>
          <PrivateRoute path="/dashboard">
            <Dashboard>
              <Switch>
                <Route
                  exact
                  path="/dashboard/overview"
                  label="Overview"
                  component={Overview}
                />
                <Route
                  path="/dashboard/data"
                  default="/dashboard/data/groups"
                  label="Trap data">
                  <Switch>
                    <Route
                      exact
                      path="/dashboard/data/groups/details"
                      component={GroupDataDetail}
                    />
                    <Sidebar headerComponent={OverviewMap}>
                      <Route
                        exact
                        path="/dashboard/data/groups"
                        label="Groups"
                        component={GroupDataOverview}
                      />
                      <Route
                        exact
                        path="/dashboard/data/traps"
                        label="Traps"
                        component={TrapDataOverview}
                      />
                    </Sidebar>
                  </Switch>
                </Route>
                <Route
                  path="/dashboard/manage"
                  default="/dashboard/manage/groups"
                  label="Manage traps">
                  <Switch>
                    <Route path="/dashboard/manage/groups/:details">
                      <Sidebar headerComponent={ManageGroupDetails}>
                        <Route
                          exact
                          path="/dashboard/manage/groups/traps"
                          label="Traps"
                          component={ManageGroupTraps}
                        />
                        <Route
                          exact
                          path="/dashboard/manage/groups/contributors"
                          label="Contributors"
                          component={ManageGroupViewers}
                        />
                      </Sidebar>
                    </Route>
                    <Sidebar>
                      <Route
                        exact
                        path="/dashboard/manage/groups"
                        label="Groups"
                        component={ManageGroups}
                      />
                      <Route
                        exact
                        path="/dashboard/manage/traps"
                        label="Traps"
                        component={ManageTraps}
                      />
                    </Sidebar>
                  </Switch>
                </Route>
                <Route
                  path="/dashboard/people"
                  default="/dashboard/people/all"
                  label="People"
                  badgeComponent={PeopleRequestsBadge}>
                  <Switch>
                    <Sidebar>
                      <Route
                        exact
                        path="/dashboard/people/all"
                        label="All people"
                        component={PeopleOverview}
                      />
                      <Route
                        exact
                        path="/dashboard/people/requests"
                        label="Requests"
                        component={PeopleRequests}
                        badgeComponent={PeopleRequestsBadge}
                      />
                      <Route
                        exact
                        path="/dashboard/people/details"
                        belongsTo="/dashboard/people/all"
                        component={PeopleDetails}
                      />
                    </Sidebar>
                  </Switch>
                </Route>
                <Route
                  path="/dashboard/settings"
                  default="/dashboard/settings/administration"
                  label="Settings">
                  <Switch>
                    <Sidebar>
                      <Route
                        exact
                        path="/dashboard/settings/administration"
                        label="Administration"
                        component={AdministrationOverview}
                      />
                      <Route
                        exact
                        path="/dashboard/settings/project"
                        label="Project"
                        component={OrganisationOverview}
                      />
                    </Sidebar>
                  </Switch>
                </Route>
                <Route component={() => <Dashboard404 />} />
              </Switch>
            </Dashboard>
          </PrivateRoute>
          <Route path="/reset" exact component={ResetPassword} />
          <Route path="/new-password" exact component={NewPassword} />
          <Route
            path="/invitation/trap/success"
            exact
            component={() => <TrapInviteSuccess />}
          />
          <Route
            path="/invitation/trap/:uuid"
            exact
            component={TrapInviteVerify}
          />
          <Route
            path="/invitation/admin/success"
            exact
            component={() => <AdminInviteSuccess />}
          />
          <Route path="/invitation/admin" exact component={AdminInviteVerify} />
          <Route path="/:page">
            <AccountScreenWrapper>
              <TransitionSwitch>
                <Route exact path="/login" component={Login} />
                <Route exact path="/create-account" component={CreateAccount} />
                <Route exact path="/email-sent" component={() => <EmailSent />} />
                <Route component={Account404} />
              </TransitionSwitch>
            </AccountScreenWrapper>
          </Route>
          <PrivateRoute exact path="/">
            <Redirect to={{ pathname: '/login' }} />
          </PrivateRoute>
        </Switch>
        <PopoverContainer key="popover" />
        <ToastContainer key="toast" />
      </div>
    </ConnectedRouter>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/containers/core/App/App.js